import styled from "styled-components";
import colours from "assets/colours";
import queries from "utils/responsivenessHelper";

const UserName = styled.div`
  color: ${colours.zltoLightBlue};
  font-size: 1.5rem;
  line-height: 166%;
  font-weight: 600;
  text-align: center;
  margin: 0 auto;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 10px;
`;

const Url = styled.div`
  color: ${colours.zltoYellow};
  font-size: 1.5rem;
  line-height: 166%;
  font-weight: 600;
  text-align: center;
  margin: 0 auto;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 10px;
  font-size:15px;
`;

const ProfilePictureWrapper = styled.div`
  border-radius: 100%;
  width: 96px;
  height: 96px;
  position: relative;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  box-shadow: 7.28px 7.28px 39.312px rgba(108, 109, 133, 0.25);
  ${queries.both({
    width: "110px",
    height: "110px",
    marginBottom: "20px",
  })}
`;

const ProfilePicture = styled.div`
  overflow: hidden;
  border-radius: 50%;
  width: 96px;
  height: 96px;
  box-shadow: 0px 2px 5px rgba(206, 210, 227, 0.3);
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;

  ${queries.both({
    width: "110px",
    height: "110px",
  })}
`;

const IconWrapper = styled.div`
  background: ${colours.white};
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 8px;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  box-shadow: 7.28px 7.28px 39.312px rgba(108, 109, 133, 0.25);
`;

const Icon = styled.img``;

const LocationRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 166%;
  color: ${colours.grey2};
  margin-bottom: 17px;

  img {
    margin-right: 8px;
  }
`;

const ActionsRow = styled.div`
  width: 100%;
  padding: 36px 0px 5px 0px;

  ${queries.both({
    paddingLeft: 22.5,
  })}
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 25px;
`;

export {
  UserInfoContainer,
  ActionsRow,
  LocationRow,
  UserName,
  ProfilePictureWrapper,
  ProfilePicture,
  Icon,
  IconWrapper,
  Url
};
